import { render, staticRenderFns } from "./AppModalForm.vue?vue&type=template&id=6a89f420&scoped=true&"
import script from "./AppModalForm.vue?vue&type=script&lang=js&"
export * from "./AppModalForm.vue?vue&type=script&lang=js&"
import style0 from "./AppModalForm.vue?vue&type=style&index=0&id=6a89f420&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a89f420",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a89f420')) {
      api.createRecord('6a89f420', component.options)
    } else {
      api.reload('6a89f420', component.options)
    }
    module.hot.accept("./AppModalForm.vue?vue&type=template&id=6a89f420&scoped=true&", function () {
      api.rerender('6a89f420', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppModalForm.vue"
export default component.exports